import clsx from 'clsx'
import React, { CSSProperties, FC } from 'react'

import { SliderData } from '@Components/Slider'

import styles from './SliderIndicator.module.scss'

export interface SliderIndicatorProps {
  className?: string
  onScrub?: (value: number) => void
  sliderState: SliderData | null
  style?: CSSProperties
}

export const SliderIndicator: FC<SliderIndicatorProps> = ({ className, onScrub, sliderState, style }) => (
  <input
    className={clsx(className, styles.sliderIndicator, (!sliderState || !sliderState.isScrollable) && styles.hidden)}
    max={sliderState?.rangeMax ?? 0}
    min={sliderState?.rangeMin ?? 0}
    onChange={onScrub ? e => onScrub(Number(e.target.value)) : () => null}
    readOnly={!onScrub}
    style={style}
    type="range"
    value={sliderState?.rangeValue ?? 0}
  />
)

